import { getMentionLabelSegment } from '@root/helpers/mentions/get-mention-label-segment';
import { mergeAttributes } from '@tiptap/core';
import MentionExtension from '@tiptap/extension-mention';
import type { DOMOutputSpec } from '@tiptap/pm/model';

import { useEntityStore } from '../../../../ContractBuilder/store';

import { formatFormValue, renderTransformedMention } from './format';

export const Mention = () => {
  return MentionExtension.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        'data-hidden': {
          default: null,
          parseHTML: (element: any) => (element.getAttribute('data-hidden') === 'true' ? true : null),
        },
        'data-source': {
          default: null,
          parseHTML: (element: any) => element.getAttribute('data-source'),
        },
      };
    },
    renderHTML({ HTMLAttributes, node }: any): DOMOutputSpec {
      const { id } = node.attrs;
      if (!id) return ['span'];

      const datapoints = useEntityStore.getState().submission?.data_items;
      const sectionId = useEntityStore.getState().modal?.block?.section_id;
      const labelSegment = getMentionLabelSegment(id);

      const value = renderTransformedMention(datapoints, sectionId, id);

      const formattedValue = value
        ? formatFormValue(id.split('.')[1], value)
        : `${this.options.suggestion?.char ?? ''}${labelSegment}`;

      if (!formattedValue) {
        return ['span'];
      }

      const attributes = mergeAttributes(
        {
          'data-type': 'mention',
          title: id,
        },
        this.options.HTMLAttributes,
        HTMLAttributes,
      );

      if (value) {
        attributes.class = 'mention-cleanup mention';
      }

      return ['span', attributes, formattedValue];
    },
  });
};
